var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTabsVertical(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "59px",
    height: "51px",
    viewBox: "0 0 59 51",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Rectangle Copy 22") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Project-Editor-4",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-22",
    stroke: "#4A4A4A",
    strokeWidth: 3,
    fill: "#FFFFFF",
    x: 2,
    y: 2,
    width: 55,
    height: 47
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-23",
    stroke: "#4A4A4A",
    strokeWidth: 3,
    fill: "#FFFFFF",
    x: 2,
    y: 2,
    width: 19,
    height: 16
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-24",
    stroke: "#4A4A4A",
    strokeWidth: 3,
    fill: "#FFFFFF",
    x: 2,
    y: 18,
    width: 19,
    height: 16
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-25",
    stroke: "#4A4A4A",
    strokeWidth: 3,
    fill: "#FFFFFF",
    x: 2,
    y: 34,
    width: 19,
    height: 15
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-14",
    transform: "translate(28.000000, 10.000000)",
    fill: "#4A4A4A"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 19,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-14",
    x: 0,
    y: 7.5,
    width: 23,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-15",
    x: 0,
    y: 13.5,
    width: 23,
    height: 3
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTabsVertical);
export default __webpack_public_path__ + "static/media/Tabs Vertical.7a755a0e.svg";
export { ForwardRef as ReactComponent };